export default "__VITE_ASSET__ZAzAwbZt__"